const mutations = {
    // getDoctorList(state, data) {
    //     api.request("/register/findSurgeryRegisterMenuList", {}, (res) => {
    //         state.list = res.data
    //     });
    // },
    GETGENEMUTATION(state, item) {
        state.list = item;
    }

}

export default mutations